import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/financial-snapshot/profile/loading';

export const Route = createFileRoute('/_private/financial-snapshots/$id')({
  pendingComponent: Loading,
});
